$(function(){
    $("body").on("click",".trigger",function(){
      var parV=$(this).parent();
      if($(this).hasClass("opened")){
        $(this).removeClass("opened");
        $(parV).removeClass("opClose")
      }
      else{
        $(this).addClass("opened");
        $(parV).addClass("opClose");
      }
    });
  //zengshimei
  //update-date:2020/11/11
  //阻止点击搜索冒泡
  $("body").on('click','.search-box',function(e){
   e.stopPropagation();
   });
  
  // 搜索
    //清空文本框内容
    $(".input_clean").click(function(){
    	$(this).prev().val("");
       var parentSer=$(this).parent().parent().parent().parent().parent().parent();
      var findRF=$(parentSer).find(".typeLpus");
      $(findRF).parent().parent().removeClass("viewingScree");
        $(findRF).parent().parent().removeClass("reveal");
      $(parentSer).find(".findNoPrinter").removeClass("existNoPrinter");
    });
    //键盘按下事件：keydown() 是在键盘按下就会触发
    //键盘弹起事件：keyup() 是在键盘松手就会触发
    $(".keyup").keyup(function (e) {
        var valTe=$(this).val().toLowerCase();
        var parentSer=$(this).parent().parent().parent().parent().parent().parent();
        $(parentSer).find(".findNoPrinter").addClass("existNoPrinter");
        var findRF=$(parentSer).find(".typeLpus");
      
        $(findRF).parent().parent().removeClass("viewingScree");
        $(findRF).parent().parent().removeClass("reveal");
        if(valTe != ""){
          $(findRF).each(function(){
            if($(this).html().toLowerCase().indexOf(valTe) >= 0){
              console.log($(this).html());
              $(this).parent().parent().addClass("reveal");
            }
            $(this).parent().parent().addClass("viewingScree");
          });
          
           //判断findNoPrinter的兄弟是否存在reveal的Class类
          if($('.findNoPrinter').nextAll().is('.reveal')){
            $(parentSer).find(".findNoPrinter").removeClass("existNoPrinter");
          }
        }else{
          $(parentSer).find(".findNoPrinter").removeClass("existNoPrinter");
        }
    });
//     搜索----end
    $("body").on('click','#subFileL .clickItem .PriSer',function(event){
      var ThisA=$(this).nextAll();
      if($(ThisA).hasClass("active_show")){
       $(ThisA).removeClass("active_show");
      }else{
        $(this).parent().parent().parent().find(".MoreNon").removeClass("active_show");
        $(ThisA).addClass("active_show");
      }
      //阻止冒泡
       event.stopPropagation(); 
    });
    $(".TyIte .er_SenLes li").click(function(){
    	var htmlVl=$(this).html();
      $(this).parent().parent().parent().find(".inner").html(htmlVl);
       $(this).parent().parent().removeClass("active_show");
      if(htmlVl == "Printer Series"){
        $(".MoreNon").removeClass("active_show");
        $(".secondItem").removeClass("clickItem");
      }else{
        var tprVl=$(this).html().toLowerCase();
          $(".secondItem .er_SenLes li").each(function(i,val){
            if($(this).attr("title") == tprVl ){
              $(this).removeClass("ShowLiPen");
            }else{
            	$(this).addClass("ShowLiPen");
            }
           });
       $(".secondItem").addClass("clickItem");
      }
    });
    //点击其他地方隐藏下拉框
       $("body").click(function(){
      $(".MoreNon").removeClass("active_show");
         $(".MoreNon").removeClass("active_showThre");
    });
    //点击产品规格的li
     $("body").on('click','#subFileL .clickItemType .PriSer',function(event){
       $(".MoreNon").removeClass("active_show");
      var ThisA=$(this).nextAll();
      if($(ThisA).hasClass("active_showThre")){
       $(ThisA).removeClass("active_showThre");
      }else{
        $(this).parent().parent().parent().find(".MoreNon").removeClass("active_showThre");
        $(ThisA).addClass("active_showThre");
      }
      //阻止冒泡
       event.stopPropagation(); 
    });
    $(".specific .er_SenLes li").click(function(){
    	var htmlVl=$(this).html();
      $(this).parent().parent().parent().find(".inner").html(htmlVl);
       $(this).parent().parent().removeClass("active_showThre");
    });
  
  //去除重复项
    var liText = '',liList = $('.specific .er_SenLes li'),listForRemove = [];
    $(liList).each(function () {
      var text = $(this).text();
      if (liText.indexOf('|'+ text + '|') == -1){
        liText += '|'+ text + '|';
      }else{listForRemove.push($(this));}
    });
	$(listForRemove).each(function () { $(this).remove(); });
    //去除重复项完成
});